// Register the namespaces  
if (typeof (Microsoft) == "undefined") Microsoft = {};
if (typeof (Microsoft.ADC) == "undefined") Microsoft.ADC = {};
if (typeof (SiteCatalystInfo) == "undefined") var SiteCatalystInfo = {};

// PARAMETERS: Application
var _RequestTimeout = 2000;
var _LinkType = { POPUP: "1", MOREHELP: "2", OTHER: "3" };

// ***********************************************************************************************
// CLASS:  Microsoft.ADC.SCLogger
//
// Functions and properties to facilitate reporting             
//***********************************************************************************************
Microsoft.ADC.SCLogger = function() {
    //*******************************************************************************************
    // PARAMETERS
    //*******************************************************************************************
    var m_this = this;
    var loggingServiceGetUrl = '';
    var handlerUrl = "RequestData.ashx?HID=412";
    var debuggingEnabled = false;
    var m_linkId = null;
    var m_popupId = null;
    var m_linktype = "3";

    //get from reporting State
    var siteCatalystLoggerEnabled = false;

    //throw exception if debbuging is enabled
    //else ignore and swallow it
    function ThrowError(excp) {
        if (debuggingEnabled) {
            throw excp;
        }

        return true;
    }


    function InitGlobals() {
        if (SiteCatalystInfo) {
            if (SiteCatalystInfo.LoggerEnabled && SiteCatalystInfo.LoggerEnabled != '') {
                siteCatalystLoggerEnabled = (SiteCatalystInfo.LoggerEnabled == "1") ? true : false;
            }

            if (SiteCatalystInfo.ServiceHostName && SiteCatalystInfo.ServiceHostName != '') {
                loggingServiceGetUrl = SiteCatalystInfo.ServiceHostName + handlerUrl;
            }
        }

    }

    //public method for throw exception
    this.ThrowError = function(excp) {
        return ThrowError(excp);
    }


    function getRequestObject() {
        var xmlHttp;
        //IE6 or below
        try { xmlHttp = new ActiveXObject("MSXML2.XMLHTTP"); return xmlHttp; } catch (e) { }
        try { xmlHttp = new ActiveXObject("Microsoft.XMLHTTP"); return xmlHttp; } catch (e) { }
        //Mozilla, IE7, Safari etc
        try { xmlHttp = new XMLHttpRequest(); return xmlHttp; } catch (e) { }
        return null;
    }


    //gets random ID
    function randomId() {
        var tm = new Date;
        tm = tm.getTime();
        var sed = (Math && Math.random) ? Math.floor(Math.random() * 10000000000000) : tm;
        return Math.floor(tm / 10800000) % 10 + sed;
    }


    //return random ID 
    this.GetRandomId = function() {
        return randomId();
    }


    //*******************************************************************************************
    // FUNCTION:  getLoggingServiceUrl
    //
    // Create the URL to the LoggingService.
    //*******************************************************************************************
    function getLoggingServiceUrl() {
        return loggingServiceGetUrl + "&buster=" + randomId() + "&type=post";
    }


    function GetXmlData() {
        var dt = new Date();
        var xmlFrag = "<?xml version= 1.0 encoding= UTF-8?><request><sc_xml_ver>1.0</sc_xml_ver><reportsuiteid>" +
                        SiteCatalystInfo.ReportingSuiteID +
                        "</reportsuiteid>" +
                        "<visitorid>" + new Date().getTime()
                        + "</visitorid><pageName>" + SiteCatalystInfo.PageName
                        + "</pageName><pageurl>" + document.URL.split("?")[0]
                        + "</pageurl><prop3>" + SiteCatalystInfo.SessionId    
                        + "</prop3><prop4>" + dt.getTime()
                        + "</prop4><prop5>" + SiteCatalystInfo.Market
                        + "</prop5><prop6>" + m_linktype
                        + "</prop6><prop9>" + GetCustomLinkId()
                        + "</prop9><prop45>" + SiteCatalystInfo.PageName
                        + "</prop45><resolution>" + screen.width + "x" + screen.height
                        + "</resolution><zip>" + SiteCatalystInfo.Zip
                        + "</zip><userAgent>" + navigator.userAgent
                        + "</userAgent><linkName>" + GetCustomLinkName()
                        + "</linkName><linkType>o</linkType></request>";

        //Not escaping the date gives error on the Omniture Servers. So returned escaped data.
        return escape(xmlFrag);
    }


    function GetCustomLinkName() {
        var linkName = SiteCatalystInfo.PageName + ":" + SiteCatalystInfo.Market;
        //Check if popup control is clicked
        if (m_popupId && m_popupId != "") linkName = linkName + ":" + m_popupId;
        //Check if another help link is clicked. For MoreHelp Link, both popupid and link id is passed to the
        //LogClick function
        if (m_linkId && m_linkId != "") linkName = linkName + ":" + m_linkId;
        return linkName;
    }

    function GetCustomLinkId() {
        if ((m_linktype == _LinkType.POPUP) && (m_popupId != null)) {
            return m_popupId;
        }
        else if ((m_linktype == _LinkType.MOREHELP || m_linktype == _LinkType.OTHER) && (m_linkId != null)) {
            return m_linkId;
        }
        else

            return '';

    }

    function ExecuteLogger(callback) {
        InitGlobals();

        //do not execute logger if disabled.
        if (siteCatalystLoggerEnabled == false) return;

        try {
            if (callback) {
                if (typeof callback != 'function') {
                    callback = null;
                }
            }
            //Get the XMLHttp request Object
            var req = getRequestObject();
            if (req != null) {
                var toId;
                req.onreadystatechange = function() {
                    try {
                        if (req.readyState == 2) {
                            window.clearTimeout(toId);
                            if (callback) callback();
                        }
                    }
                    catch (ex) {
                        ThrowError(ex);
                    }
                }

                var postUrl = getLoggingServiceUrl();
                var content = GetXmlData();
                req.open("POST", postUrl, true);
                req.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
                req.send(content);

                toId = window.setTimeout(function() { req.abort(); try { if (callback) callback(); } catch (ex) { ThrowError(ex); } }, _RequestTimeout);
            }

        }
        catch (excp) {
            ThrowError(excp);
        }
    }

    /*
    Generic Javascript API in ADCenter system, that enables us to log and click any link in the UI. This future proofs
    us. All that needs to be done is to pass in the name of link that is being clicked. Ideall, a naming convention 
    should be agreed upon and UA devs consulted.   The format for the custom link generated to be sent to SC data
    collection servers to the is:
    Friendly Page name (without.aspx extension) : market : linkName
    */
    this.LogUserClick = function(linkName) {
        m_popupId = null;
        if (linkName && linkName != '') {
            m_linkId = linkName.toString().toLowerCase();
            m_linktype = _LinkType.OTHER;
            ExecuteLogger();
        }
    }


    /*Log the Click event on a link
    //  ev -- event object
    //  id -- id of the object clicked
    //  linkid -- identifier of the link passed
    //  linktype -- {POPUP: "1", MOREHELP : "2", OTHER : "3"}
    */
    this.LogClick = function(ev, id, popId, lnkid, linktype) {

        switch (linktype) {
            case _LinkType.POPUP:
                if (IsPopupImageClicked(ev, id) || (ev == "grid")) {
                    LogUAPopupClick(popId);
                }

                break;

            case _LinkType.MOREHELP:

                if (m_popupId && m_popupId != "")
                    m_popupId = m_popupId.toLowerCase();
                m_linkId = lnkid.toString().toLowerCase();
                //alert(popupId + ":" + linkId);
                m_linktype = _LinkType.MOREHELP;
                ExecuteLogger();
                break;

            case _LinkType.OTHER:
                m_popupId = null;
                if (lnkid && lnkid != '') {
                    m_linkId = lnkid.toString().toLowerCase();
                    m_linktype = _LinkType.OTHER;
                    ExecuteLogger();
                }
                break;

            default:
                break;

        }
        return false;
    }

    //Public method for logging popupup Clicks
    this.LogPopupClick = function(popId) {
        LogUAPopupClick(popId);
    }

    //Function to Check if PopupImage was Clicked
    //id = ClientID of the target popup Image, ev is the current OnClick Event 
    function IsPopupImageClicked(ev, id) {
        var origEl;
        ev = window.event || ev;
        if ((ev != null) && (ev != "grid")) {
            origEl = ev.target || ev.srcElement;
            if (origEl.id == id) {
                //|| CoordHelper.IsMouseInsideContainer($(id), ev)) 
                return true;
            }
        }
        else { return false; }
    }



    function LogUAPopupClick(popId) {
        if (popId && popId != '') {
            m_popupId = popId.toLowerCase();
            m_linkId = null;
            m_linktype = _LinkType.POPUP;
            ExecuteLogger();
        }
    }

};

//***********************************************************************************************
// SINGLETON: SCLogger
// Single instance of Microsoft.ADC.SCLogger
//***********************************************************************************************

var SCLogger = new Microsoft.ADC.SCLogger();

